<p-chips
  [(ngModel)]="selectedItems"
  (ngModelChange)="onModelChange()"
  [placeholder]="placeholder()"
  [inputId]="inputId()"
  [allowDuplicate]="false"
  [caseSensitiveDuplication]="false"
  [separator]="separator"
></p-chips>
